module.exports = __webpack_public_path__ + "img/estudiantes_antiguos.ec09a558.png";